import React from 'react'
import { apiFormat, dateConverter, format } from '@cbgms/base/utils/datetime'
import { IWorkorder, IWorkorderResponse } from '@cbgms/api'
import { Button, Icon, List, Modal } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import { Loader } from '@carsys/ui'

interface IWorkorderSelectionModalProps {
  modalOpen: boolean
  isLoading: boolean
  workorders: IWorkorderResponse[]
  closeModal: () => void
  onClickSelectWorkorder: (workorder: IWorkorder) => void
  onClickCreateNewWorkorder: () => void
}

export const WorkorderSelectionModal: React.FC<IWorkorderSelectionModalProps> = props => {
  const { workorders, onClickSelectWorkorder, onClickCreateNewWorkorder, closeModal, modalOpen, isLoading } = props
  const hasWorkorders = workorders && workorders.length > 0
  const { t } = useTranslation()

  const workorderSelect = (workorder: IWorkorder) => {
    onClickSelectWorkorder(workorder)
  }

  const newWorkorderSelect = async () => {
    await onClickCreateNewWorkorder()
  }

  return (
    <Modal open={modalOpen} onClose={() => closeModal()} closeOnDimmerClick>
      <Modal.Header>{t('historic_parts.choose_workorder_title')}</Modal.Header>
      <Modal.Content>
        {t('historic_parts.choose_workorder_description')}
        <br />
        <List divided relaxed selection>
          {isLoading && <Loader loading />}
          {!hasWorkorders && (
            <List.Item key='0' data-testid='no-workorder-message'>
              {t('vehicle.no_workorders_found')}
            </List.Item>
          )}
          {workorders?.map((wo, key) => (
            <List.Item key={key}>
              <List.Icon name='clipboard list' size='large' verticalAlign='middle' />
              <List.Content>
                <Button
                  data-testid='button-update-workorder-from-modal'
                  color='green'
                  icon='add'
                  floated='right'
                  onClick={() => {
                    workorderSelect(wo.Workorder)
                  }}
                />
                <List.Header>{`${wo.Workorder.ID}`}</List.Header>
                <List.Description>
                  {t('historic_parts.order_created_on', {
                    date: dateConverter(format.dayDateTime, apiFormat.iso).format(wo.Workorder.CreatedAt)
                  })}
                </List.Description>
              </List.Content>
            </List.Item>
          ))}
        </List>
      </Modal.Content>
      <Modal.Actions>
        <Button data-testid='button-cancel-workorder-modal' color='red' onClick={closeModal}>
          <Icon name='cancel' />
          {t('global.cancel')}
        </Button>
        <Button data-testid='button-add-workorder-from-modal' onClick={newWorkorderSelect}>
          <Icon name='add' />
          {t('historic_parts.add_to_new_order')}
        </Button>
      </Modal.Actions>
    </Modal>
  )
}

WorkorderSelectionModal.displayName = 'WorkorderSelectionModal'
export default WorkorderSelectionModal
